/**
 * WidthResizeHandle — 사이드바/패널 가장자리에 붙는 세로 드래그 핸들.
 *
 * useResizableWidth의 handleProps를 그대로 스프레드해 배선한다. 부모는
 * position: relative여야 하며, 핸들은 지정한 가장자리에 풀-높이로 붙는다.
 * 평소엔 투명하고 호버·드래그·키보드 포커스에서만 하이라이트 선이 나타난다.
 */

import { Box } from '@mui/material';
import type { ResizeHandleWiring } from '@/shared/hooks/useResizableWidth';

interface WidthResizeHandleProps extends ResizeHandleWiring {
  /** 부모의 어느 가장자리에 붙일지 */
  edge: 'left' | 'right';
  /** 드래그 중 여부 — 하이라이트 유지용 (useResizableWidth.dragging) */
  active?: boolean;
}

const WidthResizeHandle = ({ edge, active = false, ...handleProps }: WidthResizeHandleProps) => (
  <Box
    role="separator"
    aria-orientation="vertical"
    aria-label="폭 조절"
    tabIndex={0}
    {...handleProps}
    sx={{
      position: 'absolute',
      top: 0,
      bottom: 0,
      [edge]: 0,
      width: 6,
      zIndex: 20,
      cursor: 'col-resize',
      touchAction: 'none',
      display: 'flex',
      justifyContent: 'center',
      outline: 'none',
      '&::after': {
        content: '""',
        width: '2px',
        height: '100%',
        borderRadius: 1,
        bgcolor: 'primary.main',
        opacity: active ? 0.8 : 0,
        transition: 'opacity 0.15s ease',
      },
      '&:hover::after, &:focus-visible::after': {
        opacity: 0.8,
      },
    }}
  />
);

export default WidthResizeHandle;
